var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRefresh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 3C15.9824 3 3 15.9824 3 32C3 48.0176 15.9824 61 32 61C48.0176 61 61 48.0176 61 32C61 15.9824 48.0176 3 32 3ZM46.9481 32.0607C46.9481 40.2792 40.2184 47.0089 32 47.0089C23.7816 47.0089 17.0519 40.2792 17.0519 32.0607L17.1124 31.3466C17.2915 27.5945 18.7802 24.1399 21.46 21.4602C22.2927 20.6275 23.7814 20.6275 24.6747 21.4602C25.0911 21.8766 25.3307 22.4721 25.3307 23.0676C25.3307 23.6631 25.0934 24.2586 24.6747 24.6749C21.8763 27.4733 20.9226 31.5231 22.1741 35.3331L22.2927 35.6913C23.7814 39.7412 27.6522 42.4812 31.9999 42.4812C37.7757 42.4812 42.421 37.7777 42.421 32.06C42.421 29.2617 41.3487 26.7005 39.4436 24.7348V27.1168C39.4436 28.3683 38.4317 29.3802 37.1802 29.3802C35.9287 29.3802 34.9168 28.3683 34.9168 27.1168V19.2569C34.9168 18.0054 35.9287 16.9935 37.1802 16.9935H44.6846C45.9361 16.9935 46.948 18.0054 46.948 19.2569C46.948 20.5084 45.9361 21.5202 44.6846 21.5202H42.6004C45.3987 24.3186 46.948 28.0683 46.948 32.0599L46.9481 32.0607Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.459553ef.svg";
export { ForwardRef as ReactComponent };